import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";




export interface State {
  show:boolean;
  message:string;
}

const defaultState: State = {
 show:false,
  message:''
};

const getters = {
  showSgw: (state: State) => state.show,
  messageSgw: (state: State) => state.message,
};

const mutations: MutationTree<State> = {
  setSgw(state:State,payload){
    state.show = payload.show
    state.message = payload.message
  },
  clearSgw(state:State){
    state.show = false
    state.message = ''
  }
};

const actions: ActionTree<State, RootState> = {

};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
